import * as Sentry from '@sentry/react'

import { env } from '@percent/partner-dashboard/env'

const logToSentry = (error: Error) => {
  Sentry.captureException(error)
}

// eslint-disable-next-line no-console
const consoleErr = (error: Error) => console.log(error)

export const logger = (error: Error) => {
  if (env.NX_PUBLIC_USE_SENTRY_LOGGER === true) {
    return logToSentry(error)
  }

  return consoleErr(error)
}
